<template>
  <div id="HistoryList">
    <div class="history_list" v-for="(item,index) in list" :key="index">
      <div class="history_list_title">
        <div>{{item.CreateDate|setTime}}</div>
        <div>{{$t('colon.orderNumber')}}<em>{{item.Code}}</em></div>
        <div class="avatar_box">
          <el-avatar class="avatar" :src="item.HeadPortrait"></el-avatar>
          <router-link tag='em' :to="{path:'/seller/detail/'+item.SellerWyAccId}">{{item.SellRealName}} ({{item.SellerIntegral
}})<span class="earth" :class="item.SellMemberSource" v-if="(item.SellMemberSource != userInfo.MemberSource)&&item.SellerWyAccId!=3"></span></router-link>
          <span class="earthUser" v-if="earthUser"></span>
        </div>
        <!-- SellerWyAccId -->
        <div class="text_blue ContactSeller" @click="allContact(item.SellerWyAccId,item.ID)">
          <div>{{$t('base.contactSeller')}}</div>
          <!-- <router-link :to="{path:'/terms/customer',query:{item:'',seller:item.SellRealName,sellerid:item.SellerWyAccId}}">Contact Seller
          </router-link> -->
        </div>
        <!-- <div v-if="(type!=1&&type!=4)&&item.OrderType==1&&CountDown(item.NewCouponDate)!='00:00'" class="GetCouponBtn" @click="GetShareCoupon(item)">
          <span class="color_greed Coupon_f">{{$t('base.getCoupon')}}</span>
        </div> -->
      </div>
      <div class="history_list_box">
        <div class="history_list_detail">
          <div v-for="(res,i) in item.Details" :key="i">
            <div class="like_box">
              <router-link class="like_box" :to="{path:'/carddetails/'+res.ID+(res.OrderDetailId?'?oid='+res.OrderDetailId:'')}">
                <el-image class="like_img" :src="res.TitImg!='没有可上传的图片'?res.TitImg+'?imageView2/2/w/200':'../static/images/noimg.svg'" fit="contain"></el-image>
                <div class="img_p">
                  <p class="line_txt3">{{res.Title}}
                  </p>
                </div>
              </router-link>
            </div>
            <!-- NewPostageMoney -->
            <div class="history_box" v-if="res.OrderType!=1">{{item.RealLowestPriceUnit}} {{res.RealLowestPrice!=null?res.RealLowestPrice:res.USD_Price}}</div>
            <div class="history_box" v-else>{{item.RealLowestPriceUnit}} {{res.USD_Price}}</div>
            <div class="history_box Quantity">x {{res.QuantitySold}}</div>
          </div>
        </div>
        <div class="history_box ship_cost">{{PostageMoney(item,0)}}<br/><span v-if="item.Quantity&&item.Quantity>1" class="text_gray">{{$tc('base.foritems',item.Quantity,{ n: item.Quantity })}}</span></div>
        <div class="history_box">
          <del v-if="item.DiscountsPrice>0&&item.OrderType==1">{{item.RealLowestPriceUnit}} {{PostageMoney(item,2)}}<br/></del>
          <span>{{item.RealLowestPriceUnit}} {{PostageMoney(item,1)}}</span>
        </div>
        <div class="history_box tracking" v-if="type==1">
          <div class="text_red" v-if="type==1">{{$t('base.toBePaid')}}</div>
          <!-- <div class="text_gray" v-if="type==1">Shipping</div> -->
        </div>
        <!-- state -->
        <div class="history_box tracking" v-if="type!=1">
          <div class="text_gray" v-if="type==2">{{$t('base.toBeShipped')}}</div>
          <div class="text_gray" v-if="type==3&&!item.IsReceive">{{$t('base.shipped')}}</div>
          <div class="text_greed" v-if="type==3&&item.IsReceive">{{$t('base.arrived')}}</div>
          <div class="" v-if="type==4&&item.SRType==1">{{$t('base.disputing')}}</div>
          <div class="" v-if="type==4&&item.SRType==2">{{$t('base.disputed')}}</div>
          <div class="" v-if="type==4&&item.SRType==3">{{$t('base.revoke')}}</div>
          <div class="text_green" v-if="type==5">{{$t('base.toLeave')}}</div>
          <div :class="item.OrderStatus>5?'':'text_green'" v-if="type==6">{{item.OrderStatus>5?$t('base.closed'):item.OrderStatus==5?$t('base.finished'):$t('base.toLeave')}}</div>
        </div>
        <div class="history_box tracking" style="padding: 0;" :class="type==1?'remain':''">
         
          <div>
            <!-- 待支付 鸽子倒计时 -->
            <!-- :class="DoveCountDown(item.CountDown,0,item.CountDownType)==1||item.CountDownType>1?'RemainingRed':''" -->
            <!-- 秒数：{{item.CountDown}}
            状态：{{item.CountDownType}}
            倒计时：{{DoveCountDown(item.CountDown)}} -->
            <div class="history_time" v-if="item.OrderStatus==1" :class="DoveCountDown(item.CountDown,0,item.CountDownType)==1||item.CountDownType>1?'RemainingRed':''">
              <i></i>
              <!-- <span>Remaining: {{CountDown(item.LastPayDate)}}</span> -->
              <span>{{$t('colon.remaining')}} {{item.CountDown>0?DoveCountDown(item.CountDown):'00:00'}}</span>
            </div>
            <!-- 跨境待收货订单，自动收货倒计时 -->
            <div class="history_time" v-if="item.BusinessType==2&&item.IsCustomAdress&&type==3&&item.CheckTimeLong>0">
              <el-tooltip :content="$t('alert.automaticreceipt')"
                  placement="left-start" effect='light'>
                <i></i>
                </el-tooltip>
              <span>{{$t('colon.remaining')}} {{item.CheckTimeLong>0?DoveCountDown(item.CheckTimeLong):'00:00'}}</span>
            </div>
            <div class="history_btn" @click="BuyItNow(item)" v-if="item.OrderStatus==1">{{$t('base.payNow')}}</div>
            <!-- 待收货 -->
            <div class="history_btn" @click="confirm(item)" v-if="item.OrderStatus==3">{{(item.BusinessType!=2||(item.BusinessType==2&&item.IsCustomAdress))?$t('base.confirmItem'):$t('base.conditionChecking')}}</div>
            <div class="history_btn" @click="confirm(item)" v-if="item.OrderStatus==5&&((item.BusinessType==2&&!item.IsCustomAdress))">{{$t('base.conditionChecking')}}</div>
            <!-- <div class="history_btn" @click="dialog(item,'Review')">Review</div> -->
            <!-- 带评价 -->
            <div class="history_btn feedback" @click="dialog(item,'comment')" v-if="type==5&&item.IsAppraisal!=1">{{$t('base.leaveFeedback')}}</div>
            <div class="history_txt">
              <router-link :to="{path:'/mycardhobby/detail/'+item.ID}">{{$t('base.viewDetails')}}</router-link>
            </div>
            <!-- 除了待支付其他都有维权按钮 -->
            <div v-if="item.SellerWyAccId!=3&&type!=1&&item.OrderStatus<5" class="cursor history_txt" @click="dialog(item,'safeguard')">{{item.SRType==0?$t('base.openCase'):$t('base.viewCaseDetail')}}</div>
            <!-- 订单完成，查看维权 -->
            <div v-if="item.SellerWyAccId!=3&&item.OrderStatus>=5&&item.SRType!=0" class="cursor history_txt" @click="dialog(item,'safeguard')">{{$t('base.viewCaseDetail')}}</div>
            <!-- 待支付修改地址 -->
            <div v-if="item.BusinessType!=2&&item.OrderStatus==1" class="history_txt" @click="dialog(item,'address')">{{$t('base.changeAddress')}}</div>
            <!-- 物流查询 -->
            <div class="cursor history_txt" @click="dialog(item,'express')" v-if="item.OrderStatus==3||item.OrderStatus==5">{{$t('base.trackingDetails')}}</div>
            <div class="history_txt feedback" @click="dialog(item,'feedback')" v-if="item.OrderStatus==5&&item.SRType==0">{{$t('base.viewFeedback')}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 优惠券弹框 coupon-->
    <get-coupon :title="dialogTitle" :dialogClass="dialogBox" :list="dialogList" :domVisible='dislogType.coupon' :couponText="couponText" @closeDialog="closeDialog" v-if='dislogType.coupon' />
    <!-- 快递运费弹框 -->
    <get-express :title="dialogTitle" :dialogClass="dialogBox" :list="dialogList" :domVisible='dislogType.express' @closeDialog="closeDialog" v-if='dislogType.express' />
    <!-- 评论弹框 comment-->
    <get-comment :title="dialogTitle" :dialogClass="dialogBox" :list="dialogList" :domVisible='dislogType.comment' :userInfo='userInfo' @closeDialog="closeDialog" v-if='dislogType.comment' />
    <!-- 修改地址弹框 address-->
    <change-address :title="dialogTitle" :dialogClass="dialogBox" :list="dialogList" :domVisible='dislogType.address' :userInfo='userInfo' @closeDialog="closeDialog" v-if='dislogType.address' />
    <!-- 维权弹框 SafeGuard-->
    <safe-guard :title="dialogTitle" :dialogClass="dialogBox" :list="dialogList" :domVisible='dislogType.safeguard' :userInfo='userInfo' @closeDialog="closeDialog" v-if='dislogType.safeguard' />
    <!-- 收货弹框 confirm-->
    <get-confirm :title="dialogTitle" :dialogClass="dialogBox" :list="dialogList" :viewList="viewList" :domVisible='dislogType.confirm' :userInfo='userInfo' @closeDialog="closeDialog" @dialog="dialog" @SetReceive='SetReceive' v-if='dislogType.confirm' />
    <get-feedback :title="dialogTitle" :dialogClass="dialogBox" :list="dialogList" memberType='2' :domVisible='dislogType.feedback' :userInfo="userInfo" @closeDialog="closeDialog" v-if='dislogType.feedback' />
  </div>
</template>
<script>
import { getInfo, addressList, getTime, setUTC, numAdd, numMulti, countDown, isNumber, GoYunXin, priceExchange, doveCountDown } from "@/api/public";
import qs from 'qs'
import GetCoupon from "@/components/dialog/coupon"; // 优惠券
import GetExpress from "@/components/dialog/express"; // 物流
import GetComment from "@/components/dialog/comment"; // 评论
import ChangeAddress from "@/components/dialog/changeaddress"; // 改地址
import SafeGuard from "@/components/dialog/safeguard"; // 维权
import GetConfirm from "@/components/dialog/confirm"; // 收货
import GetFeedback from "@/components/dialog/feedback"; // 评价详情

export default {
  name: 'historylist',
  components: {
    GetCoupon,
    GetExpress,
    GetComment,
    GetConfirm,
    ChangeAddress,
    SafeGuard,
    GetFeedback
  },
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      //list: this.list,
      earthUser: false,
      nowData: new Date().getTime(),
      timer: "",
      dovetimer: '',
      userInfo: '',
      dialogBox: 'dialogBox',
      dialogVisible: false,
      dialogTitle: '',
      dialogList: '',
      viewList: '',
      dialogStyle: '',
      EquityVal: '',
      ID: 0,
      dislogType: this.$enumInfo.dislogType,
    }
  },
  props: {
    list: {},
    type: 0,
    arrived: String
  },
  filters: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    setTimeY(val) {
      return getTime(val, -8, 3, 'cn').split('|')[0]
    },
  },
  created() {
    this.userInfo = getInfo()
    //this.getAddressList();
    this.cardTimer();
    this.DoveTimer();
    this.closeDialog('safeguard', false)
  },
  computed: {

  },
  methods: {

    //价格加法，obj:传入的obj,type:判断是邮费还是总价，0:邮费、1:总价、2：折扣前总价
    PostageMoney(obj, type) {
      let isRealPostageMoney = obj.RealPostageMoney != null ? true : false
      let price = 0
      if (type == 0) {
        if (isRealPostageMoney) {
          price = isNumber(obj.RealPostageMoney)
        } else {
          price = isNumber(obj.USD_PostageMoney)
        }
        //let newPrice = this.areaSymbol+" " + price.toLocaleString()
        let newPrice = obj.RealLowestPriceUnit+" " + price.toLocaleString()
        if (price <= 0) {
          // newPrice = obj.NewPostageMoney!='shipping free'?obj.NewPostageMoney:'$ 0.00' 2022/11/16 念改
          var NewPostageMoney=obj.NewPostageMoney.toLowerCase()
          var type='shipping free,free shipping'
          newPrice = type.indexOf(NewPostageMoney)==-1 ? obj.NewPostageMoney.toLocaleString() : this.$t('base.freeShipping')
        }
        return newPrice
      } else if (type == 1) {
        if (isRealPostageMoney) {
          price = numAdd(isNumber(obj.RealLowestPrice), isNumber(obj.RealPostageMoney))
        } else {
          price = isNumber(obj.USD_TotalPrice)
        }
        if (obj.OrderType != 1) {
          //var Service=numAdd(priceExchange(obj.ServiceFee,'USD'), priceExchange(obj.TaxPrice,'USD'))
          //var Service=numAdd(isNumber(obj.ServiceFeeUsd), isNumber(obj.TaxPriceUsd))

          var Service = 0
          Service = numAdd(isNumber(obj.ServiceFeeUsd), isNumber(obj.TaxPriceUsd))
          if(obj.BusinessType==2&&!obj.IsCustomAdress){
            Service = isNumber(obj.ServiceFeeUsd)
          }
          // if (obj.ServiceFeeUsd) {
          //   Service = numAdd(isNumber(obj.ServiceFeeUsd), isNumber(obj.TaxPriceUsd))
          // } else if (obj.ExchangeRate) {
          //   Service = numAdd(numMulti(obj.ServiceFee, obj.ExchangeRate), numMulti(obj.TaxPrice, obj.ExchangeRate))
          // } else {
          //   Service = numAdd(priceExchange(obj.ServiceFee, 'USD'), priceExchange(obj.TaxPrice, 'USD'))
          // }
          price = numAdd(isNumber(price), isNumber(Service))
        }

        return price.toFixed(2).toString()
      }else if(type==2){
        if (isRealPostageMoney) {
          price = numAdd(isNumber(obj.RealLowestPrice), isNumber(obj.RealPostageMoney)+isNumber(obj.DiscountsPrice))
        } else {
          price = isNumber(obj.USD_TotalPrice)
        }
        return price.toLocaleString()
      }
    },
    // 云信
    allContact(val,oid) {
      if (this.userInfo) {
        GoYunXin(this.userInfo, val,oid,1001)
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    // 鸽子倒计时setInterval
    DoveTimer() {
      let that=this;
      if (that.type == 1 || that.type == 3) {
        that.dovetimer = setInterval(() => {
          try{
            that.list.map(res => {
            if (res.CountDown > 0 && that.type == 1) { // 未支付订单鸽子倒计时
              res.CountDown = res.CountDown - 1
            } else if (res.CheckTimeLong > 0 && that.type == 3) { // 待收货状态 跨境订单确认收货倒计时
              res.CheckTimeLong = res.CheckTimeLong - 1
            }
          })
          }catch(e){
            console.log(e)
          }
        }, 1000);
      }
    },
    // itemEnd:倒计时，type:0 判断是否鸽子一阶段12小时,countDownType//鸽子倒计时状态
    DoveCountDown(itemEnd, type, countDownType) {
      var time = itemEnd
      //console.log('var time = itemEnd',itemEnd)
      var countDownType = countDownType
      if (itemEnd) {
        time = doveCountDown(itemEnd)
        //console.log(time)
      }
      if (type == 0) {
        //43200 12小时
        if (itemEnd <= 43200 && countDownType == 1) {
          return 1
        } else {
          return 0
        }
      } else {
        return time
      }
    },
    CountDown(itemEnd) {
      var time = '';
      if (itemEnd) {
        itemEnd = itemEnd.toString().replace(/-/g, "/")
        let val = setUTC(itemEnd, -8, 'cn')
        let newval = setUTC(this.nowData, -8)
        return countDown(val, newval)
      }
      return time;
    },

    // 订单确认收货
    SetReceive(obj, type) {
      //console.log(obj)
      let that=this
      if (type != 0) {
        let that = this
        let data = { token: that.userInfo.ChineseToken, memberId: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, OrderID: obj.ID }
        if (data.OrderID == undefined) {
          data.OrderID = obj.OrderId
        }
        this.$root.$emit("confirmLoading", true);
        this.$post(this.$interface.SetReceive, qs.stringify(data)).then(res => {
          if (res.result != 0) {
            that.handleClose()
            this.$emit('getDialog', false)
            this.closeDialog('confirm', false)
            if(obj.BusinessType == 2){
              //跨境订单 买家确认弹框
              if(obj.IsCustomAdress==null||!obj.IsCustomAdress){
                that.Checking()
              }
            }
          } else {
            this.$message({
              type: 'error',
              message: res.msg
              //message: "You can't confirm item because it is disputing!"
            });
          }
        })
      } else {
        // this.$confirm('<div style="text-align: center">Will you confirm the item?</div>', 'Confirm Item', {
        this.$confirm('<div style="text-align: center">'+that.$t('alert.willYouConfirmItem')+'</div>', that.$t('base.confirmItem'), {
          confirmButtonText: that.$t('base.confirm'),
          cancelButtonText: that.$t('base.cancel'),
          customClass: "confirmBox",
          lockScroll: false,
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.SetReceive(obj)
        }).catch(() => {
          this.handleClose()
          this.closeDialog('confirm', false)
        });
      }
    },
    //弹框 Card Hobby Confirming
    doc() {
      let that=this
      this.$alert('<div style="text-align: center">'+that.$t('alert.cardHobbyProces')+'</div>', that.$t('base.conditionChecking'), {
        confirmButtonText: that.$t('base.ok'),
        lockScroll: false,
        dangerouslyUseHTMLString: true,
        callback: action => {}
      });
    },
    // 跨境订单：官方检查完商品，买家确认后
    Checking() {
      let that=this
      this.$alert('<div style="text-align: center">'+that.$t('alert.itemBeShownIn')+'"<a href="/#/mycardhobby/warehouse" style="color:#5F6DAE">'+that.$t('base.overseasWarehouse')+'</a>"</div>', that.$t('symbol.checkingCompleted'), {
        confirmButtonText: that.$t('base.viewNow'),
        lockScroll: false,
        dangerouslyUseHTMLString: true,
        callback: action => {
          this.$router.push({
          path: '/mycardhobby/warehouse'
        })
        }
      });
    },
    // 订单确认收货弹框
    confirm(obj) {
      let that=this
      //console.log(obj)
      if (obj.BusinessType != 2||(obj.BusinessType == 2&&obj.IsCustomAdress)) {
        // this.$confirm('<div class="confirmData">If you confirm the item before arrived, the order will be finished</div>', 'Will you confirm the item?', {
        this.$confirm('<div class="confirmData">'+that.$t('alert.ReceivingWarn')+'</div>', that.$t('symbol.caution'), {
          confirmButtonText: that.$t('base.confirm'),
          cancelButtonText: that.$t('base.cancel'),
          customClass: "confirmBox Caution",
          lockScroll: false,
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.SetReceive(obj)
        }).catch(() => {});
      } else {
        let that = this
        let data = { token: that.userInfo.ChineseToken, memberId: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, orderId: obj.ID }
        this.$get(this.$interface.GetOrderCheck, data).then(res => {
          if (res.result != 0) {
            if (res.data.data.length > 0) {
              this.dialog(res.data, 'confirm', obj)
            } else {
              this.doc()
            }
          } else {
            this.doc()
          }
        })
        //this.dialog(obj, 'view')
      }
    },
    // 弹框 val=> comment:评论商品,confirm:跨境订单收货确认,address:更改地址,safeguard:维权,express:物流信息,coupon:优惠券
    dialog(obj, val, res) {
      let that = this;
      if (val == 'comment') {
        that.dialogTitle = that.$t('base.toLeave');
        that.dialogBox = "dialogBox"
        that.dislogType[val] = true;
        that.dialogList = JSON.parse(JSON.stringify(obj))
      } else if (val == 'confirm') {
        that.dialogTitle = that.$t('base.conditionChecking');
        that.dialogStyle = 'view';
        that.dialogBox = "dialogBox"
        that.dislogType[val] = true;
        that.viewList = JSON.parse(JSON.stringify(obj))
        that.dialogList = JSON.parse(JSON.stringify(res));
      } else if (val == 'address') {
        that.dialogTitle = that.$t('base.shipTo');
        that.dialogBox = "dialogBox"
        that.dislogType[val] = true;
        that.dialogList = JSON.parse(JSON.stringify(obj))
        //this.GetOrderDetail(obj)
      } else if (val == 'express') {
        that.dialogTitle = that.$t('base.trackingDetails');
        that.dialogBox = "dialogBoxTracking";
        that.dislogType[val] = true;
        that.dialogList = JSON.parse(JSON.stringify(obj))
        //this.GetExpress(obj)
      } else if (val == 'safeguard') {
        //that.GetSafe(obj)
        that.dialogTitle = that.$t('base.disputed');
        that.dialogBox = "dialogBoxPro pro"
        that.dislogType[val] = true
        that.dialogList = JSON.parse(JSON.stringify(obj));
      } else if (val == 'coupon') {
        that.dialogTitle = that.$t('base.stepLink');
        that.dialogStyle = 'coupon';
        that.dislogType[val] = true;
        that.dialogList = JSON.parse(JSON.stringify(obj))
      } else if (val == 'feedback') {
        that.dialogTitle = that.$t('base.feedbackDetail');
        that.dialogStyle = 'dialogBox';
        that.dislogType[val] = true;
        obj.OrderId=obj.ID
        that.dialogList = JSON.parse(JSON.stringify(obj))
      }
      //that.dialogList = obj;
      // if(that.dialogStyle == 'view'){
      //   that.viewList=obj
      //   that.dialogList = res;
      // }
      // console.log(1111112,obj)
      //
    },
    // 付款
    BuyItNow(val) {
      let that = this;
      let data = val
      // OrderType=1 跳购物车的支付否则跳普通订单的支付
      if (data.OrderType != 1) {
        window.sessionStorage.setItem('check', JSON.stringify(data))
        //console.log(data.OrderType)
        this.$router.push({
          path: '/pay/checkout/' + val.ID
        })
      } else {
        let commodityIds = [];
        let cuantitySold = [];
        let couponMemberID = [];
        val.Details.map(item => {
          commodityIds.push(item.ID);
          cuantitySold.push(item.QuantitySold);
        })
        let data = { total: val.USD_TotalPrice, commodityIds: commodityIds, cuantitySold: cuantitySold, Details: val.Details }
        window.sessionStorage.setItem('check', JSON.stringify(data))
        this.$router.push({
          path: '/pay/cartcheckout/' + val.ID
        })
      }
    },
    // 关闭弹框
    handleClose() {
      this.dialogVisible = false
      this.EquityVal = "";
    },
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
      if (val == 'comment') {
        this.$emit('getDialog', false)
      } else if (val == 'address') {
        this.$emit('getDialog', false)
      }
    },
    // 获取是否能分享优惠券
    GetShareCoupon(val) {
      let that = this;

      this.couponText = this.baseURL + '#/coupon?e=' + val.ID + '&t=' + that.userInfo.MappingUserId + '&m=' + encodeURIComponent(that.userInfo.HeadPortrait)
      let data = { memberId: that.userInfo.MappingUserId, orderId: val.ID }
      this.$get(this.$interface.GetShareCoupon, data).then(res => {
        if (res.result != 0) {
          this.dialog(val, 'coupon')
        } else {
          this.$message({
            type: 'error',
            //message: res.msg
            message: that.$t('alert.shareExpired')
          });
        }
      })
    },

  },
  //离开页面后清除定时器
  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.dovetimer);
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/historylist.css";
@import "../../../static/css/flag.css";


.history_list_box .like_box .img_p {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.history_list_box .like_box .img_p span {
  color: #a0a0a0;
  font-size: 12px;
  margin-top: 8px;
}

.history_list_box .like_box .img_p p {
  line-height: 1.2;
  text-align: left;
  font-size: 14px;
}

.history_list_box .like_box .img_p p span {
  display: block;
  line-height: 1.2;
}

.history_list_box .like_box .img_p p span i:before {
  content: 'Tracking Number:';
  word-break: break-all;
}

.history_list_title>.ContactSeller {
  color: #333;
}

.history_list_title>.ContactSeller>div:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #5F6DAE;
}

.history_list_title>.GetCouponBtn {
  font-weight: bold;
  padding-right: 9px;
  position: absolute;
  right: 15px;
  background: url(../../../static/images/icon/icon_dollar.svg) right center no-repeat;
}

.Quantity {
  width: 75px;
}

.Coupon_f {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/list/history.vue